<template>
	<div>404 Page Not Found</div>
</template>
<style scoped>
div {
	padding: 50px;
	font-size: 35px;
}
</style>
